import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GungLanguageConfigService } from 'gung-common';
import { AuthService, CartService, CustomerProductPrice, GungAnonymousConfigService, GungCurrencyPipe, PriceConfigService, PriceService, ProductService } from 'gung-standard';
import { BehaviorSubject, catchError, filter, first, Observable, of, Subject, switchMap } from 'rxjs';
import { TyloPriceMarkup } from '../components/tylo-customer-b2c-price-markup-modal/tylo-customer-b2c-price-markup-modal.component';

@Injectable({
  providedIn: 'root'
})
export class TyloPriceConfigService extends PriceConfigService {
  public enableHidePrice = true;
  activeGroups: { [s: string]: boolean };
  public showB2CPrices: Subject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    protected currencyPipe: GungCurrencyPipe,
    cartService: CartService,
    protected authService: AuthService,
    protected priceService: PriceService,
    protected productService: ProductService,
    protected gungAnonymousConfigService: GungAnonymousConfigService,
    protected translateService: TranslateService,
    protected languageConfigService: GungLanguageConfigService,
    protected http: HttpClient
) {
    super(currencyPipe, cartService, priceService, productService, authService, gungAnonymousConfigService, translateService, languageConfigService);
    this.authService
      .getCurrentUser()
      .pipe(
        filter(user => !!user),
        first()
      )
      .subscribe(user => {
        this.activeGroups = user.activeGroups;
        this.hidePrice.next(this.activeGroups.NOPRICE);
      });
  }

  public getPrice(
    price: CustomerProductPrice | string,
    mode: string,
    display?: string | boolean,
    currency?: string
  ): string {
    if (this.activeGroups.NOPRICE) {
      return '';
    }
    return super.getPrice(price, mode, display, currency);
  }

  getB2CPriceMarkup(customerId: string): Observable<TyloPriceMarkup> {
    const params = new HttpParams().set('customerId', customerId);
    return this.http.get<TyloPriceMarkup>('json/tylo-markup', { params }).pipe(
      catchError(() => of({ customerId, markupPercentage: 0 })),
      switchMap(customerPriceMarkup => {
        if (!customerPriceMarkup) {
          return of({ customerId, markupPercentage: 0 });
        }
        return of(customerPriceMarkup);
      })
    )
  }

  updateB2CPriceMarkup(customerPriceMarkup: TyloPriceMarkup): Observable<TyloPriceMarkup> {
    return this.http.post<any>('json/tylo-markup/create ', customerPriceMarkup);
  }

  calculatePriceMarkup(customerPriceMarkup: TyloPriceMarkup, grossPriceValue: number): number {
    return (grossPriceValue * (100 + customerPriceMarkup.markupPercentage) / 100);
  }
}
